import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';

const FormInputDateTimePickerElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form Date Time Input',
  icon: 'DocumentTextIcon',
  description: 'Adds a date time input form control',
  properties: [
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description:
        'Choose a data source that this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Markup',
      name: 'datasourceFieldMarkup',
      editor: 'textbox',
      description: markupDescription,
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'layout',
    'margin',
    'padding',
    'alignment',
    {
      label: 'Use Non-Theme Input',
      name: 'useNonThemeInput',
      editor: 'boolean',
      description: 'If true will customise the input different to the theme',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'iconMargin',
      label: 'Icon Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '0 0 0 2',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'icon',
      label: 'Icon',
      description: '',
      editor: 'icon',
      type: 'string',
      default: 'DocumentIcon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'iconsize',
      label: 'Icon Size',
      description: '',
      editor: 'iconsize',
      type: 'number',
      default: 6,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Icon Color',
      name: 'iconColor',
      editor: 'color',
      description: 'The color of the stat box icon',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      editor: 'color',
      description: 'The background color of the element',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Date and Time',
      name: 'operatingMode',
      editor: 'dropdown',
      default: 'date',
      description: 'Whether to store date, time or date and time',
      options: [
        {
          label: 'Date',
          value: 'date'
        },
        {
          label: 'Date and Time',
          value: 'datetime'
        },
        {
          label: 'Time',
          value: 'time'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Format',
      name: 'dateformat',
      editor: 'textbox',
      default: 'Do MMM YYYY h:mm a',
      description: 'The moment.js format of the date http://www.moment.js',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Show Label',
      name: 'showLabel',
      description: 'Hide the Label',
      editor: 'switch',
      default: false,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Disabled',
      default: false,
      name: 'disabled',
      editor: 'switch',
      description: 'If the field is disabled',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Label',
      name: 'label',
      editor: 'textbox',
      description: 'The label of the field',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Label Font',
      name: 'labelFont',
      editor: 'fontsize',
      description: 'The padding within the input label',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Label Color',
      name: 'labelColor',
      editor: 'color',
      description: 'The text color of the input label and the date',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the date and label',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of the date and label',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Placeholder Text',
      name: 'placeholder',
      editor: 'textbox',
      description: 'The placeholder to display in the field',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Display Existing Value',
      name: 'showExistingValue',
      description:
        'Whether to show the existing value for this field in the input when the screen is loaded',
      editor: 'switch',
      default: true,
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Validation Type',
      name: 'validation',
      editor: 'dropdown',
      description: 'The validation type of the text',
      options: [
        { label: '<Not Set>', value: ' ' },
        { label: 'Date', value: 'date' }
      ],
      default: 'date',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Validate On',
      name: 'validateOn',
      default: 'keypress',
      editor: 'dropdown',
      description: 'The validation type of the text',
      options: [
        { label: '<Not Set>', value: ' ' },
        { label: 'Key Press', value: 'keypress' }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Required',
      default: true,
      name: 'required',
      editor: 'switch',
      description: 'If the field is required',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Custom Regex',
      name: 'customRegex',
      default: '',
      editor: 'textbox',
      description: 'Custom Regex',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Custom Error Message',
      name: 'customErrorMessage',
      default: '',
      editor: 'textbox',
      description: 'Custom Error Message',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Error Message Color',
      name: 'errorMessageColor',
      default: '#000000',
      editor: 'colorpicker',
      description: 'The color of the error message',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Error Message Font',
      name: 'errorMessageFont',
      editor: 'fontsize',
      description: 'The color of the error message',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Error Message Alignment',
      name: 'errorMessageAlignment',
      editor: 'alignment',
      description: 'The alignment error message',
      default: 'justify-left',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Error Message Margin',
      name: 'errorMessageMargin',
      editor: 'boundary',
      description: 'The margin around the error message',
      default: '10 0 10 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Error Message Padding',
      name: 'errorMessagePadding',
      editor: 'boundary',
      description: 'The padding within the error message',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default FormInputDateTimePickerElementFields;
